export default __webpack_public_path__ + "static/media/Grid interface add plus 2.0977c93e.svg";